<template>
  <div :class="$style.root">
    <router-link
      :to="`/projects/${project.prevSlug}`"
      :class="[$style.arrow, $style.arrowPrev, {[$style.disable]: !project.prevSlug}]"
      @click.native="click"
    >
      Предыдущий
    </router-link>
    <router-link
      :class="$style.linkBack"
      to="/projects"
    >
      Назад к проектам
    </router-link>
    <router-link
      :to="`/projects/${project.nextSlug}`"
      :class="[$style.arrow, $style.arrowNext, {[$style.disable]: !project.nextSlug}]"
      @click.native="click"
    >
      Следующий
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { GET_PROJECT } from 'store/getters';

export default {
  name: 'ProjectPagination',
  computed: {
    ...mapGetters({
      project: GET_PROJECT,
    }),
  },
  methods: {
    click(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style lang="scss" module>
@import '../styles/variables';
@import '../styles/helpers';

.root {
  @extend %container;
  @extend %section;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 45px;
  padding-bottom: 45px;
}

$hover-color: darken($red-light, 20%);

.arrow {
  @include set-fz-lh(18, 38);
  position: relative;
  font-weight: 600;
  color: $red-light;
  text-decoration: none;
  transition: opacity 0.3s, color 0.3s, transform 0.3s;

  @include media('<=phone') {
    font-size: 0;
    width: 44px;
    height: 44px;
    border: 2px solid $red-light;
    border-radius: 50%;
  }
}

.arrow:hover,
.arrow:focus {
  color: $hover-color;
}

.arrow:active {
  @include media('<=phone') {
    transform: scale(0.96);
  }
}

.arrow::before {
  content: '';
  position: absolute;
  top: 3px;
  width: 30px;
  height: 30px;
  border-top: 5px solid $red-light;
  border-left: 5px solid $red-light;
  border-radius: 3px;
  transition: border 0.3s;

  @include media('<=phone') {
    width: 15px;
    height: 15px;
    top: 12px;
    border-width: 3px;
  }
}

.arrow:hover::before,
.arrow:focus::before {
  border-color: $hover-color;
}

.arrowPrev {
  padding-left: 50px;

  @include media('<=phone') {
    padding-left: 0;
  }
}

.arrowPrev::before {
  left: 0;
  transform: rotate(-45deg);

  @include media('<=phone') {
    left: 15px;
  }
}

.arrowNext {
  padding-right: 50px;

  @include media('<=phone') {
    padding-right: 0;
  }
}

.arrowNext::before {
  right: 0;
  transform: rotate(135deg);

  @include media('<=phone') {
    right: 15px;
  }
}

.arrow.disable {
  pointer-events: none;
  color: $red-light;
  opacity: 0.6;

  &::before {
    border-color: $red-light;
  }
}

.linkBack {
  @extend %button;

  @include media('<=phone') {
    border: 2px solid $red-light;
    background-color: $white;
    color: $red-light;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectPagination.vue